import React from 'react';
import { Group } from './styles';

const RadioGroup = ({ children }) => <Group>{children}</Group>;

export default RadioGroup;
